import React from 'react';

function IconActionButton({
  icon: Icon,
  label,
  onClick,
  variant = 'default',
  className = '',
}) {
  const variantClass =
    variant === 'danger'
      ? 'text-content-muted hover:text-red-600 hover:bg-red-50 hover:border-red-200'
      : 'text-content-muted hover:text-forge-700 hover:bg-forge-50 hover:border-forge-200';

  return (
    <button
      type="button"
      onClick={onClick}
      aria-label={label}
      title={label}
      className={`inline-flex items-center gap-1.5 rounded-lg border border-surface-border bg-white px-2 py-1.5 text-xs font-medium transition-colors ${variantClass} ${className}`}
    >
      <Icon className="h-3.5 w-3.5 shrink-0" aria-hidden />
      <span>{label}</span>
    </button>
  );
}

export default IconActionButton;
